let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dORQw")).then(() => parcelRequire('5EVoG'));